<template>
  <div class="mb-12">
    <h2 class="text-565656 fsize18 font-semibold border-b pb-4">E-commerce</h2>

    <div class="grid gap-4 grid-cols-3 mt-6">
      <div
        class="cursor-pointer effecthover rounded-lg"
        v-for="(item, index) in cards"
        :key="'item -' + index"
        @click="
          selectedProject.intellectualProperty === false
            ? handleClick(item.route)
            : ''
        "
        :class="
          selectedProject.intellectualProperty === true
            ? 'bg-f5f5f5 cursor-not-allowed opacity'
            : 'cursor-pointer'
        "
      >
        <div class="flex items-center bg-lightf4f5f6 border-round p-3">
          <div class="flex gap-4 items-center w-10/12">
            <img
              :src="item.image"
              class="object-contain w-16 h-16 bg-ec rounded-lg"
              alt="banh"
            />

            <div class="w-full">
              <h3 class="col-4f fsize14 font-medium mb-0">
                {{ item.title }}
              </h3>
            </div>
          </div>
          <div class="w-2/12 flex justify-end cursor-pointer">
            <div>
              <!-- <img
                src="@/assets/images/aright.png"
                class="w-35px rounded-full"
              /> -->
              <div
                class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-5 h-5"
                  class="text-secondary font-semibold flex"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cards: [
        // {
        //   id: "01",
        //   title: "New Product",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/Brained/Ecom/ecom.svg",
        //   route: "ecommerce-Newproduct",
        // },
        {
          id: "02",

          title: "Categories",
          image: require("@/assets/images/icons/Category.svg"),
          route: "ecommerce-categories",
        },
        // {
        //   id: "08",

        //   title: "Sub-Categories",
        //   image:
        //     "https://nimbuscluster.blob.core.windows.net/server01/Brained/Ecom/ecom1.svg",
        //   route: "subcategory-ecom",
        // },

        // {
        //   id: "04",

        //   title: "My Products",
        //   image: require("@/assets/images/icons/My product.svg"),
        //   route: "ecommerce-Myproduct",
        // },
        {
          id: "05",

          title: "Tags",
          image: require("@/assets/images/icons/Tags.svg"),
          route: "ecommerce-Tags",
        },
        // {
        //   id: "06",

        //   title: "Domain Setup",
        //   image: require("@/assets/images/icons/domain stup.svg"),
        //   route: "",
        // },
        {
          id: "07",

          title: "Attributes",
          image: require("@/assets/images/icons/brand guidelines.svg"),
          route: "ecommerce-Attribute",
        },

        // {
        //   id: "08",

        //   title: "Order Management",
        //   image: require("@/assets/images/icons/order management.svg"),
        //   route: "ecommerce-OrderManagment",
        // },

        // {
        //   id: "09",

        //   title: "Order Returns",
        //   image: require("@/assets/images/icons/order return.svg"),
        //   route: "ecommerce-OrderReturns",
        // },

        {
          id: "10",

          title: "Coupon Management",
          image: require("@/assets/images/icons/coupon management.svg"),
          // route: "coming",
          route: "ecommerce-CouponManagement",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("admin", ["userModules", "login", "allModules"]),
    ...mapState("user", ["selectedProject"]),
  },
};
</script>
